<template>
  <div class="chart-tab-container">
    <div class="chart-head">
      反应近期系统内用户点击次数较通常情况下的点击次数的变动程度
    </div>
    <div class="chart-box">
      <empty-box v-if="!sourceList || sourceList.length===0" />
      <div id="chartBar" style="width: 97%; height: 280px"></div>
    </div>
  </div>
</template>

<script>
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts/core";
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart } from "echarts/charts";
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
} from "echarts/components";
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from "echarts/features";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";
import { getYiDong } from "@/api/homeinfo.js";

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
]);
import EmptyBox from '@/components/EmptyBox/index.vue'
export default {
  name: "BarChart",
  components:{
    EmptyBox
  },
  data() {
    return {
      chartReSize: null,
      // 表格跨度值
      setpValue: 25,
      sourceList: [],

      chartInfo: [
        // {
        //   id: 1,
        //   name: "石墨",
        //   val: 11,
        // },
        // {
        //   id: 2,
        //   name: "沥青",
        //   val: 19,
        // },
        // {
        //   id: 3,
        //   name: "稀土",
        //   val: 22,
        // },
        // {
        //   id: 4,
        //   name: "石油",
        //   val: 32,
        // },
        // {
        //   id: 5,
        //   name: "煤炭",
        //   val: 45,
        // },
        // {
        //   id: 6,
        //   name: "石焦油",
        //   val: 78,
        // },
        // {
        //   id: 7,
        //   name: "石墨",
        //   val: 65,
        // },
        // {
        //   id: 8,
        //   name: "甲醇",
        //   val: 94,
        // },
      ],
    };
  },
  async mounted() {
    await this.initYDInfo();
    this.initCharInfo();
    this.initChart();
  },
  methods: {
    /**
     * @description 对异动数据进行赋值
     */
    async initYDInfo() {
      let res = await getYiDong();
      if(res.code === 200){
        this.sourceList = res.data
      }
      // const defaultRes = [ { "ProductName": "PVA", "Transaction": 391.65 }, { "ProductName": "PBT", "Transaction": 185.35 }, { "ProductName": "多晶硅", "Transaction": 163.96 }, { "ProductName": "甲醇", "Transaction": 153.51 }, { "ProductName": "涤纶长丝", "Transaction": 142.81 }, { "ProductName": "煤沥青", "Transaction": 140.68 }, { "ProductName": "氨纶", "Transaction": 139.86 }, { "ProductName": "硫磺", "Transaction": 135.76 }, { "ProductName": "电解液", "Transaction": 131.01 }, { "ProductName": "丙烯", "Transaction": 130.48 }, { "ProductName": "碳酸锂", "Transaction": 128.56 }, { "ProductName": "硫酸", "Transaction": 125.39 }, { "ProductName": "六氟磷酸锂", "Transaction": 123 }, { "ProductName": "高温煤焦油", "Transaction": 113.97 }, { "ProductName": "氧化铝", "Transaction": 112.1 }, { "ProductName": "尿素", "Transaction": 110.21 }, { "ProductName": "聚乙烯", "Transaction": 105.94 }, { "ProductName": "玉米", "Transaction": 105.23 }, { "ProductName": "石油焦", "Transaction": 104.87 }, { "ProductName": "锌锭", "Transaction": 104.54 } ]  
      // this.sourceList = defaultRes;
    },
    /**
     * [{ ProductName: "原油" ,Transaction: 228.2}]
     * @param {Array} sourceList 源数据数组
     */
    transformInfo(sourceList) {
      const labelName = "operationName";
      const valName = "change";
      let resList = [["产品名", "异动指数"]];
      sourceList.forEach((sourceItem) => {
        if (sourceItem[labelName] && sourceItem[valName]) {
          resList.push([sourceItem[labelName], sourceItem[valName]]);
        }
      });

      return resList;
    },
    initCharInfo() {
      this.chartInfo = this.transformInfo(this.sourceList.slice(0, 10));
    },
    initChart() {
      if (!this.chartInfo || this.chartInfo.length === 0) return;

      var myChart = echarts.init(document.getElementById("chartBar"));
      let option = {
        animation: true,
        grid: {
          top: "5%",
          bottom: "10%",
          left: "20%",
          right: "5%",
        },
        tooltip: {
          animation: true,
          show: true,
          borderWidth: 0,
          padding: [5, 10],
          // formatter: (params) => {
          //   let data = params["data"];
          //   return `
          //         <div style="min-width: 5rem;text-align:center" >
          //            ${data[0]}
          //           <br/>
          //           ${data[1]}
          //         </div>
          //         `;
          // },
        },
        dataset: [
          {
            source: this.chartInfo,
            // [
            //   ["石墨", 11],
            //   ["沥青", 19],
            //   ["稀土", 22],
            //   ["石油", 32],
            //   ["煤炭", 45],
            //   ["石焦油", 78],
            //   ["石墨", 65],
            //   ["甲醇111", 100],
            //   ["甲醇222", 104],
            //   ["甲醇33", 114],
            //   ["甲醇44", 124],
            // ],
          },
        ],
        series: [
          {
            type: "bar",
            datasetIndex: 0,
            itemStyle: {
              // emphasis:{
              //   color: '#ff0000'
              // }
            },
          },
        ],
        xAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          lineStyle: {
            type: "dashed",
          },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            show: true,
            formatter: "{value}",
          },
          splitLine: {
            show: true,
            interval: 1,
            lineStyle: {
              type: "dashed",
            },
          },
          nameTextStyle: {
            width: "80",
          },
          axisLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        // series: [
        //   {
        //     type: "bar",
        //     name: "2015",
        //     data: [89.3, 92.1, 94.4, 85.4],
        //   },
        //   {
        //     type: "bar",
        //     name: "2016",
        //     data: [95.8, 89.4, 91.2, 76.9],
        //   },
        //   {
        //     type: "bar",
        //     name: "2017",
        //     data: [97.7, 83.1, 92.5, 78.1],
        //   },
        // ],
      };
      myChart.setOption({
        ...option,
      });
      window.onresize = function () {
        if (this.chartReSize) clearTimeout(this.chartReSize);
        this.chartReSize = setTimeout(() => {
          setTimeout(() => {
            myChart.resize();
          });
        }, 500);
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-tab-container {
  .chart-head {
    // height: 30px;
    padding: 10px;
    font-size: 12px;
    background: #f2f3f5;
  }
  .chart-box {
    width: 100%;
    // padding-bottom: 10px;
  }
}
</style>